import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TooltipProvider"], null, {
        default: _withCtx(() => [
            _createVNode($setup["Tooltip"], {
                open: $props.open,
                "onUpdate:open": _cache[0] || (_cache[0] = ($event) => ($setup.emit('update:open', $event)))
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["TooltipTrigger"], { "as-child": "" }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    }),
                    (!$props.disabled && ($props.text || _ctx.$slots.content))
                        ? (_openBlock(), _createBlock($setup["TooltipContent"], {
                            key: 0,
                            side: $props.position,
                            "data-static-id": $props.staticId ?? undefined,
                            class: _normalizeClass($props.contentClass)
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "content", {}, () => [
                                    _createTextVNode(_toDisplayString($props.text), 1 /* TEXT */)
                                ])
                            ]),
                            _: 3 /* FORWARDED */
                        }, 8 /* PROPS */, ["side", "data-static-id", "class"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["open"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
